<template>
  <div v-if="isMobile">
    <NavBar
      v-if="
        !$route.path.includes('rule') &&
        $route.path !== '/home' &&
        $route.path !== '/' &&
        !$route.path.includes('/auth/')
      "
    />
    <router-view
      :class="$route.path.includes('/auth/') ? '' : 'middle-container'"
    ></router-view>

    <audio controls ref="audioPlayer" v-show="false">
      <source src="/build/assets/music/fbmusic.mp3" type="audio/mpeg" />
      Your browser does not support the audio element
    </audio>
  </div>
  <!-- Replace 'your-audio-file.mp3' with the path to your audio file -->
  <div v-else class="h-100vh" style="background: black">
    <div class="col-md-8 col-lg-4 mx-auto h-100vh">
      <iframe
        name="iframe1"
        :src="desktopIframeSrc"
        class="iframe-style"
      >
      </iframe>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import LuckyWheel from "../frontend/components/LuckyWheel.vue";

export default {
  components: {
    LuckyWheel,
  },
  data() {
    return {
      isMobile: false,
      isLuckyWheel: false,
      isHideForToday: false,
      showPopup: false,
    };
  },
  async mounted() {
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
    this.checkPopupStatus();
    // this.fetchWebsiteData();
  },
  computed: {
    ...mapGetters(["getFBOrder"]),
    ...mapState(["music"]),
    desktopIframeSrc() {
      const path = this.$route.fullPath || "/home";
      return `${window.location.origin}${path}`;
    },
  },

  watch: {
    music() {
      //do something on data change
      const audio = this.$refs.audioPlayer;
      audio.volume = 0.7;
      if (this.music === true) {
        audio.play();
      } else {
        audio.pause();
      }
    },
  },

  methods: {
    testing() {
      this.isLuckyWheel = true;
      console.log("testing");
    },
    closePopup() {
      this.showPopup = false;
      this.$store.commit("setMusic", true);
      const today = new Date().toISOString().split("T")[0];
      if (this.isHideForToday)
        localStorage.setItem("popupDismissedDate", today);
    },
    checkPopupStatus() {
      const today = new Date().toISOString().split("T")[0];
      const lastDismissedDate = localStorage.getItem("popupDismissedDate");
      if (lastDismissedDate !== today) {
        this.showPopup = true;
      }
    },

    ...mapMutations(["setWholeFBMatches"]),
    ...mapActions(["fetchUser"]),
    closeModalOutside(event) {
      if (event.target.classList.contains("modal")) {
        this.$router.go();
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get("/website-infos");
        // console.log('this.$store.state.androidVersion', this.$store.state.androidVersion);
        // if(res.data.data[0].androidVersion !== this.$store.state.androidVersion) {
        //   $('#version').modal('show');
        // }
      } catch (error) {
        console.log(error);
      }
    },
    openModalVoucher() {
      if (this.$store.state.fb_order.fb_matches.length === 0) {
        const dataError =
          this.$store.state.language === "en"
            ? "Please select some teams!"
            : "အသင်းတစ်ချို့ ရွေးပေးပါ။";
        this.dialog(dataError);
      } else {
        const matches = this.getFBOrder.fb_matches;
        if (!this.$store.state.betAmount) {
          $("#amount").modal("show");
        } else {
          for (let i = 0; i < matches.length; i += 1) {
            matches[i].bet_amount = this.$store.state.betAmount;
          }
          this.setWholeFBMatches(matches);
          $("#mobile-voucher").modal("show");
        }
      }
    },

    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
          this.$store.state.language === "en"
            ? "Go Back"
            : "နောက်သို့ပြန်သွားမည်။",
      }).then(() => {
        // on close
      });
    },
  },
};
</script>
<style scoped>
.iframe-style {
  width: 100vh;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  z-index: 10000;
  background: #0c0c0c;
}
.floating {
  position: fixed;
  width: 90px;
  z-index: 1;
  animation: floating 20s infinite;
  bottom: 130px;
  right: 0%;
}
#closeButton {
  border: none;
  background: none;
  position: absolute;
  left: -15px;
  font-size: 20px;
  font-weight: bold;
  color: #b7b7b7;
}

@keyframes float {
  0% {
    transform: translatey(0px);
  }

  50% {
    transform: translatey(-20px);
  }

  100% {
    transform: translatey(0px);
  }
}

.cart-number {
  top: -2px !important;
  left: -2px !important;
}
.cart-number {
  position: absolute;
  top: -3px;
  left: -3px;
  text-align: center;
}
.middle-container {
  min-height: 75vh;
}
@media (max-width: 768px) {
  .cart-container {
    font-size: 30px !important;
  }
  .social-contacts div {
    width: 60px !important;
    height: 60px !important;
    margin-top: 15px;
  }
  #social-contacts .badge-circle.badge-md {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }
  .cart-container {
    visibility: visible;
    font-size: 16px;
  }
  .middle-container {
    min-height: 100vh;
    margin: 0px !important;
    /* padding-top: 0.1rem !important; */
    /* margin-bottom: 50px !important; */
  }
}
</style>
